import axios from 'axios'

import auth from '@/auth'
import {vm} from '@/main'
import {ToProgress} from 'toprogress2'

import Promise from 'bluebird'

Promise.config({
  cancellation: true
})

class APIState {
  constructor(http) {
    this.http = http
  }

  post(path, body, config) {
    return this.http.post(path, body, config)
  }
}

class APIDispatcher {
  constructor(state) {
    this.state = state
    /* eslint-disable no-new */
    this.progress = new ToProgress({height: '2px'})
    this.numPosts = 0
  }

  post(path, body) {
    console.log(API)

    let self = this
    return new Promise((resolve, reject, onCancel) => {
      this.progress.start()
      this.numPosts++

      if (auth.isAuthenticated()) {
        body.sid = auth.sid()
      }

      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();


      this.state.post(path, body, {cancelToken: source.token})
        .then(function (response) {
          self.finishRequest()

          let data = response.data
          if (data.errorCode === 'ERR_INVALID_SESSION') {
            vm.$notify.error('Session Expired', 'Please log in again')
            auth.logout()
            vm.$router.go('/')
            return
          }

          resolve(data)
        })
        .catch(function (error) {
          self.finishRequest()
          if (axios.isCancel(error)) {
            console.log('post cancelled: ' + error)
          } else {
            console.log('Could not reach the API: ' + error)
            reject(error)
          }
        })

      onCancel(function () {
        source.cancel('cancelled by user')
      })
    })
  }

  finishRequest() {
    this.numPosts--
    if (this.numPosts === 0) {
      this.progress.finish()
    }
  }

  success(response) {
    return (response && response.errorCode && response.errorCode === 'SUCCESS')
  }
}

let API_STATE = new APIState(axios.create({
  baseURL: API + '/api'
}))

export const Dispatcher = new APIDispatcher(API_STATE)



// WEBPACK FOOTER //
// ./src/APIDispatcher.js